import { render } from "./cabinet.vue?vue&type=template&id=37ae1fdc&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=js"
export * from "./cabinet.vue?vue&type=script&lang=js"

import "./cabinet.vue?vue&type=style&index=0&id=37ae1fdc&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ae1fdc"]])

export default __exports__